module.exports = __webpack_public_path__ + "static/skiing-21fbc58f5ad46a92b6987728135e9624.jpg";